<template>
  <div class="modal fade" id="user-access-modal" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">USER ACCESS: {{ userAccess.name }}</h4>
        </div>
        <div class="modal-body">
          <div class="clearfix"></div>
          <spinner v-if="loading"></spinner>
          <template v-else>
            <vue-good-table :columns="columns"
                            :rows="rows"
                            :pagination-options="{
                              'enabled': true,
                              'perPage': 10,
                              'perPageDropdown': [5, 10, 15],
                              'dropdownAllowAll': false,
                            }"
            >
              >
              <div slot="emptystate">
                No data.
              </div>
            </vue-good-table>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  import Spinner from "@/components/Spinner";
  import Breadcrumbs from "@/components/Breadcrumbs";
  import Pagination from '@/components/Pagination.vue'
  import {getUserInfo} from "@/http-common";
  import DatePicker from 'vue2-datepicker';
  import {mapActions, mapGetters} from 'vuex';

  export default {

    components: {
      Pagination,
      Spinner,
      DatePicker,
      'breadcrumb-bar': Breadcrumbs
    },

    props: ['id'],

    data() {
      return {
        loading: false,
        columns: [
          {
            label: 'Account',
            field: 'account',
            filterOptions: {enabled: true}
          },
          {
            label: 'User Role',
            field: 'role',
            filterOptions: {enabled: true}
          },
          {
            label: 'Last Login',
            field: 'last_login',
            filterOptions: {enabled: true}
          }
        ],
        results: 0
      }
    },

    computed: {
      ...mapGetters({
        'userAccess': 'getUserAccess'
      }),
      rows() {
        return this.userAccess.rows.map(item => {
          if (item.last_login !== '' && item.last_login.date !== '') {
            item.last_login = this.$options.filters.formatDate(item.last_login.date);
          }
          return item;
        });
      },
      format() {
        return getUserInfo('date_format')
      },
    },

    mounted() {
      if (this.id) {
        this.loadUserAccess(this.id);
        $('#user-access-modal').modal('show');
      }

      $('#user-access-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },

    methods: {
      ...mapActions({
        loadUserAccess: 'loadUserAccess'
      }),
      fetchUserActivityLog(params) {
        this.loading = true;
        this.loadUserAccess.finally(() => {
          this.loading = false;
        })
      },
    },

    inject: {
      $validator: '$validator'
    },
  }
</script>



// WEBPACK FOOTER //
// UserAccessModal.vue?64f5cefe